import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation UpsertTaxFilingReadiness(
    $input: TaxFilingReadinessUpsertInput!
  ) {
    upsertTaxFilingReadiness(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxFilingReadiness {
        id
        jurisdiction
        registrationStatus
        registeredOn
        nexusEffectiveOn
        taxIdentifierReference
        assignedFilingFrequency
        externalAutofileStatus
        notes
        reviewedById
        reviewedAt
      }
    }
  }
  ${ErrorMessageInfo}
`;
